import { ElementType, Question } from "@archetypes/form";

export const DEFAULT_RATING = 5;

export const FIELD_EVENT_DEBOUNCE_TIME = 100;

export const NO_DATA: string = "--";

export const MAX_FILE_SIZE_TO_UPLOAD = 5 * 1024 * 1024; // 5 MB
export const MAX_FILE_SIZE_TO_UPLOAD_STRING =
  Math.round(MAX_FILE_SIZE_TO_UPLOAD / (1024 * 1024)) + `MB`;

export enum GroupBy {
  CreatedAt = "CREATED_AT",
  UpdatedAt = "UPDATED_AT",
}
export const ALL_RESPONSES_ID = "All Responses";
export const DATE_TIME_FORMAT = "d/M/yy - h:mm aa";

export const SYSTEM_FIELDS_IDS_ENUM = {
  CreatedAt: "CREATED_AT",
  UpdatedAt: "UPDATED_AT",
  CreatedBy: "CREATED_BY",
};

export const SYSTEM_FIELDS_IDS = [
  SYSTEM_FIELDS_IDS_ENUM.CreatedAt,
  SYSTEM_FIELDS_IDS_ENUM.UpdatedAt,
  SYSTEM_FIELDS_IDS_ENUM.CreatedBy,
];

export const SYSTEM_FIELDS: Question[] = [
  {
    id: SYSTEM_FIELDS_IDS_ENUM.CreatedAt,
    type: ElementType.DatePicker,
    title: "Created At",
    content: {
      label: "Created At",
      visible: true,
    },
  },
  {
    id: SYSTEM_FIELDS_IDS_ENUM.UpdatedAt,
    type: ElementType.DatePicker,
    title: "Updated At",
    content: {
      label: "Updated At",
      visible: true,
    },
  },
  {
    id: SYSTEM_FIELDS_IDS_ENUM.CreatedBy,
    type: ElementType.Users,
    title: "Created By",
    content: {
      label: "Created By",
      visible: true,
    },
  },
];
